var exports = {
  "Y$": "StatusCheckHeader__JgU5q5",
  "jn": "suggestionsFooter__i0rOgv",
  "Ms": "suggestionsFooterText___hGRYm",
};

module.exports = exports;
